import { render, staticRenderFns } from "./records-consumption-table.vue?vue&type=template&id=0f7102b3&scoped=true&"
import script from "./records-consumption-table.vue?vue&type=script&lang=js&"
export * from "./records-consumption-table.vue?vue&type=script&lang=js&"
import style0 from "./records-consumption-table.vue?vue&type=style&index=0&id=0f7102b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7102b3",
  null
  
)

export default component.exports